<div class="row">
  <div class="col-md-4">
    <h3>Helpful Links</h3>
    <hr />
    <ul>
      <li><a href="https://sparkitecture.github.io/SparkitectureDocs/" target="_blank">Sparkitecture
          Online Documentation</a></li>
      <li><a target="_blank" href="https://tfs.sparkhound.com/Sparkhound/Sparkitecture">Sparkitecture DevOps</a>
      </li>
      <li><a target="_blank" href="https://tfs.sparkhound.com/Sparkhound/Sparkitecture/_workitems">Sparkitecture
          Work Items</a></li>
      <hr />
      <li *ngIf="loggedIn"><a routerLink="/application-settings">Application Settings</a></li>
      <li *ngIf="loggedIn"><a routerLink="/examples">CRUD Operation Examples</a></li>
      <li *ngIf="loggedIn"><a routerLink="/error-logs">Error Logs</a></li>
    </ul>
  </div>
  <div class="col-md-8">
    <h3>Contact Info:</h3>
    <hr />
    <div class="row">
      <div class="card col">
        <div class="card-body">
          <h5 class="card-title">Steve Schaneville</h5>
          <h6 class="card-subtitle mb-2 text-muted">Principal Consultant</h6>
          <p class="card-text">
            <strong>Email: </strong> <a
              href="mailto:steve.schaneville@sparkhound.com">steve.schaneville@sparkhound.com</a>
          </p>
        </div>
      </div>
      <div class="card col">
        <div class="card-body">
          <h5 class="card-title">John Harvey</h5>
          <h6 class="card-subtitle mb-2 text-muted">Senior Consultant</h6>
          <p class="card-text">
            <strong>Email: </strong> <a href="mailto:John.Harvey@sparkhound.com">John.Harvey@sparkhound.com</a>
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="card col">
        <div class="card-body">
          <h5 class="card-title">Sam North</h5>
          <h6 class="card-subtitle mb-2 text-muted">Senior Consultant</h6>
          <p class="card-text">
            <strong>Email: </strong> <a href="mailto:sam.north@sparkhound.com">sam.north@sparkhound.com</a>
          </p>
        </div>
      </div>
      <div class="card col">
        <div class="card-body">
          <h5 class="card-title">Vance Fontenot</h5>
          <h6 class="card-subtitle mb-2 text-muted">Senior Consultant</h6>
          <p class="card-text">
            <strong>Email: </strong> <a href="mailto:vance.fontenot@sparkhound.com">vance.fontenot@sparkhound.com</a>
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="card col">
        <div class="card-body">
          <h5 class="card-title">Matthew Shirk</h5>
          <h6 class="card-subtitle mb-2 text-muted">Consultant</h6>
          <p class="card-text">
            <strong>Email: </strong> <a href="mailto:matthew.shirk@sparkhound.com">matthew.shirk@sparkhound.com</a>
          </p>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>
</div>
